export default {
  message: {
    hello: "你好，世界！",
  },
};
